import React from "react";
import { Form, Button, Radio } from "antd";
import { AgGridReact } from "ag-grid-react";
import "../RegistrationCSS.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AntDSelectWrapper from "../../../../Components/CustomWrappers/AntDSelectWrapper";
import {
  Actions,
  contact_person_columnsDefs,
  QUERY,
  STATUS_RADIO,
} from "../../../../constants";
import { emailValidator, phoneNumberValidator, telephoneValidator } from "../validators";
import AntDMultipleTextBoxWrapper from "../../../../Components/CustomWrappers/AntDMultipleTextBox";

class ContactPersonDetails extends React.Component {
  gridApi = null;

  state = {
    columnDefs: [
      {
        headerName: "Actions",
        width: 90,
        cellRendererFramework: (params) => {
          // VIEW IN CASE OF EDIT MODE AND EDIT/DELETE IN CASE OF NEW REG
          if (params.data.is_active && !params.data.is_migrated) {
            return <EyeOutlined className="grid-icons" />;
          }
          return (
            <>
              <EditOutlined
                className="grid-icons"
                onClick={() =>
                  this.props.handleContactPersonDetails(
                    params.data.id,
                    Actions.update
                  )
                }
              />
              <DeleteOutlined
                className="grid-icons"
                onClick={() =>
                  this.props.handleContactPersonDetails(
                    params.data.id,
                    Actions.delete
                  )
                }
              />
            </>
          );
        },
      },
      ...contact_person_columnsDefs,
      {
        headerName: "Status",
        field: "contact_person_status",
        width: 300,
        pinned: "right",
        cellRendererFramework: (params) => {
          return (
            <div className="ag-radio">
              <Radio.Group
                defaultValue={params.data.contact_person_status}
                onChange={(event) =>
                  this.props.handleContactPersonDetails(
                    params.data.id,
                    Actions.radio,
                    event
                  )
                }
              >
                {Object.keys(STATUS_RADIO).map((key) => {
                  return (
                    <Radio value={STATUS_RADIO[key]}>{STATUS_RADIO[key]}</Radio>
                  );
                })}
              </Radio.Group>
            </div>
          );
        },
      },
    ],
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
  };

  render() {
    const {
      formRef,
      isDisabled,
      additional_details,
      handleContactPersonDetails,
      handleChange,
      isIndia,
      updateGrid,
      hideActions,
      handleMultivalueFields,
      multivalue_fields
    } = this.props;

    const { columnDefs } = this.state;

    return (
      <div className="row form-box">
        {this.props.source && this.props.source === QUERY.msme ? (
          <legend className="form-legend">
            Company Contact Person Details
          </legend>
        ) : (
        <legend className="form-legend">Contact Person Details</legend>
        )}

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="contact_person_title"
            id="contact_person_title"
            required={false}
            disabled={isDisabled}
            label="Title"
            message="Enter Title"
            placeholder="Enter Title"
            app="masters"
            entity="contactpersontitle"
            validators=""
            options={[]}
            onChange={handleChange}
            primary_key_field="title_id"
            allowClear={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="contact_person_first_name"
            id="contact_person_first_name"
            required={false}
            disabled={isDisabled}
            label="First Name"
            message="Enter First Name"
            placeholder="Enter First Name"
            casetype="uppercase"
            validators=""
            maxlength={35}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="contact_person_last_name"
            id="contact_person_last_name"
            required={false}
            disabled={isDisabled}
            label="Last Name"
            message="Enter Last Name"
            placeholder="Enter Last Name"
            casetype="uppercase"
            validators=""
            maxlength={35}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="contact_person_designation"
            id="contact_person_designation"
            required={false}
            disabled={isDisabled}
            label="Designation"
            message="Enter Designation"
            placeholder="Enter Designation"
            app="masters"
            entity="contactpersondesignation"
            validators=""
            options={[]}
            onChange={handleChange}
            primary_key_field="id"
            formRef={formRef}
            prefixId={true}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="contact_person_department"
            id="contact_person_department"
            required={false}
            disabled={isDisabled}
            label="Department"
            message="Enter Department"
            placeholder="Enter Department"
            app="masters"
            entity="contactpersondepartment"
            validators=""
            options={[]}
            onChange={handleChange}
            primary_key_field="id"
            formRef={formRef}
            prefixId={true}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDMultipleTextBoxWrapper
            decorator="contact_person_mobile_number"
            id="contact_person_mobile_number"
            required={false}
            disabled={isDisabled}
            label="Mobile Number"
            message="Enter Mobile Number"
            placeholder="Enter Mobile Number"
            validators={isIndia ? [{ validator: phoneNumberValidator }] : ""}
            maxlength={15}
            formRef={formRef}
            handleChange={handleMultivalueFields}
            formData={multivalue_fields}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDMultipleTextBoxWrapper
            decorator="contact_person_telephone_number"
            id="contact_person_telephone_number"
            required={false}
            disabled={isDisabled}
            label="Telephone Number"
            message="Enter Telephone Number"
            placeholder="Enter Telephone Number"
            validators={[{ validator: telephoneValidator }]}
            maxlength={20}
            formRef={formRef}
            handleChange={handleMultivalueFields}
            formData={multivalue_fields}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDMultipleTextBoxWrapper
            decorator="contact_person_email"
            id="contact_person_email"
            required={false}
            disabled={isDisabled}
            label="Email"
            message="Enter Email ID"
            placeholder="Enter Email ID"
            validators={[{ validator: emailValidator }]}
            maxlength={241}
            formRef={formRef}
            handleChange={handleMultivalueFields}
            formData={multivalue_fields}
          />
        </div>

        <div className="col-lg-12 col-md-12">
          <Form.Item label=" ">
            <Button
              className="float-right"
              type="primary"
              htmlType="button"
              onClick={() => handleContactPersonDetails(null, Actions.insert)}
            >
              {Actions.add}
            </Button>
          </Form.Item>
        </div>

        {updateGrid && (
          <div className="p-4 col-lg-12 col-md-12">
            <div
              className="table-responsive table-bordered
                table table-hover table-bordered
                ag-theme-balham gridViewDisplay 
                director-grid-height"
            >
              <AgGridReact
                columnDefs={columnDefs}
                onGridReady={this.onGridReady}
                rowData={additional_details.contact_person_details}
                handleContactPersonDetails={handleContactPersonDetails}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ContactPersonDetails;
